import { apiClient } from "@/lib/api-client";
import type {
  WalletDto,
  PaginatedTransactionsResult,
  WalletTransactionDto,
  TopUpPaymentRedirectResult,
  InitiateTopUpRequest,
  WalletTopUpDto,
} from "../dtos/wallet.dto";
import type {
  AiUsageSummaryDto,
  PaginatedAiUsageEventsResult,
} from "../dtos/ai-usage.dto";

// ── Wallet ───────────────────────────────────────────────────────────────────

export async function getWallet(organizationId: string): Promise<WalletDto> {
  const { data } = await apiClient.get<WalletDto>("/wallet", {
    params: { organizationId },
  });
  return data;
}

// ── Transactions ─────────────────────────────────────────────────────────────

export async function getWalletTransactions(
  organizationId: string,
  page = 1,
  pageSize = 20,
): Promise<PaginatedTransactionsResult> {
  const { data } = await apiClient.get<PaginatedTransactionsResult>(
    "/wallet/transactions",
    { params: { organizationId, page, pageSize } },
  );
  return data;
}

export async function getWalletTransaction(
  organizationId: string,
  transactionId: string,
): Promise<WalletTransactionDto> {
  const { data } = await apiClient.get<WalletTransactionDto>(
    `/wallet/transactions/${transactionId}`,
    { params: { organizationId } },
  );
  return data;
}

// ── Top-up ───────────────────────────────────────────────────────────────────

export async function initiateTopUp(
  request: InitiateTopUpRequest,
): Promise<TopUpPaymentRedirectResult> {
  const { data } = await apiClient.post<TopUpPaymentRedirectResult>(
    "/wallet/topup",
    request,
  );
  return data;
}

export async function getTopUpStatus(
  organizationId: string,
  topUpId: string,
): Promise<WalletTopUpDto> {
  const { data } = await apiClient.get<WalletTopUpDto>(
    `/wallet/topup/${topUpId}`,
    { params: { organizationId } },
  );
  return data;
}

// ── AI Usage ─────────────────────────────────────────────────────────────────

export async function getAiUsageSummary(
  organizationId: string,
  from?: string,
  to?: string,
): Promise<AiUsageSummaryDto> {
  const { data } = await apiClient.get<AiUsageSummaryDto>(
    "/wallet/ai-usage/summary",
    { params: { organizationId, from, to } },
  );
  return data;
}

export async function getAiUsageEvents(
  organizationId: string,
  page = 1,
  pageSize = 20,
  from?: string,
  to?: string,
): Promise<PaginatedAiUsageEventsResult> {
  const { data } = await apiClient.get<PaginatedAiUsageEventsResult>(
    "/wallet/ai-usage/events",
    { params: { organizationId, page, pageSize, from, to } },
  );
  return data;
}
